import React, { useState } from 'react';
import { Spring, config, animated } from 'react-spring/renderprops';
import './styles/main.scss';
import Topbar from './topbar';
import Menu from './menu';
import Navbar from './navbar';
import { FaEllipsisV } from 'react-icons/fa';

const Layout = ({ children }) => {
  const [menu, setMenu] = useState(false);
  const menuBtn = menu ? <FaEllipsisV onClick={ () => setMenu(false) } className='ico menuBtn' /> : <FaEllipsisV onClick={ () => setMenu(true) } className='ico menuBtn' />;
  return(
  <Spring native config={ config.slow } from={{ opacity: 0 }} to={{ opacity: 1 }}>
    {props => <animated.div style={ props }> 
      <main style={{ marginBottom: '80px' }}>
        <Topbar Menu={ menuBtn } />
        <Menu open={ menu } />
        <Navbar />
        { children }
      </main>
    </animated.div>}
  </Spring>
  );
}
export default Layout;